<div class="most-ordered-item" (click)="onProductClick(product.id)" [ngStyle]="{
    width: mainView ? '200px' : '100%',
    margin: mainView ? '0px 8px' : '0px'
  }">
    <!-- Card body: iOS CustomRoundedShape (steep top slope), drawn as an SVG so it themes. -->
    <svg class="most-order-bg" viewBox="0 0 200 200" preserveAspectRatio="none" aria-hidden="true">
        <path d="M 0,50 Q 0,40 9.58,42.87 L 190.42,97.13 Q 200,100 200,110 L 200,190 Q 200,200 190,200 L 10,200 Q 0,200 0,190 Z"
              fill="var(--menu-item-background, #252525)"
              stroke="var(--menu-image-border, #2B2B2B)" stroke-width="1"
              vector-effect="non-scaling-stroke" />
    </svg>
    <!-- Image tile: plain <img> shown at its natural ratio (object-fit: contain) in a themed rounded
         tile — same approach as the product cards in the menu list (.menu-category-item .product-image),
         so photos aren't cropped (cover) or letterboxed inside the old skewed SVG shape. Always shown. -->
    <div class="product-image" [ngStyle]="{
            width: mainView ? '150px' : '120px',
            height: mainView ? '120px' : '100px'
          }">
        <img *ngIf="hasValidImage(product)" [src]="getProductImageSrc(product)" alt=""
             (load)="onImageLoad()" (error)="onImageError()"
             [style.opacity]="imageLoaded ? 1 : 0" />
        <img *ngIf="!hasValidImage(product)" class="placeholder" src="../../assets/ImageBrokenPadded.svg" alt="" />
        <div class="image-placeholder" *ngIf="hasValidImage(product) && !imageLoaded">
            <div class="spinner"></div>
        </div>
    </div>

    <div class="most-ordered-item-info" [style.bottom]="mainView ? '12px' : '12px'">
        <h3>{{getProductName(product, currentLang)}}</h3>
        <div class="most-ordered-item-info-bottom">
            <h4 *ngIf="!product.on_sale">
                {{product.regular_price | price}} <span [innerHTML]="currencySymbol"></span>
                <span class="second-price" *ngIf="isSecondCurrencyActive() && getSecondPrice(product.regular_price)">  {{getSecondPrice(product.regular_price)}} <span [innerHTML]="getSecondCurrencySymbol()"></span></span>
            </h4>
            <h4 *ngIf="product.on_sale">
                {{product.sale_price | price}} <span [innerHTML]="currencySymbol"></span>
                <span class="original-price">{{product.regular_price | price}} <!-- <span [innerHTML]="currencySymbol"></span> --></span>
                <div style="display: flex; align-items: center; gap: 4px;">
                    <span class="second-price" *ngIf="isSecondCurrencyActive() && getSecondPrice(product.sale_price)">  {{getSecondPrice(product.sale_price)}} <span [innerHTML]="getSecondCurrencySymbol()"></span></span>
                    <span class="second-price second-regular-price" *ngIf="isSecondCurrencyActive() && getSecondPrice(product.regular_price)">  {{getSecondPrice(product.regular_price)}} <span [innerHTML]="getSecondCurrencySymbol()"></span></span>
                </div>
            </h4>
            <!-- Icon + number only: this card is half a phone wide and already carries a price and
                 a stepper on one row, so the wording would push one of them off. -->
            <app-supplement-combinations-badge *ngIf="combinationCount > 1"
                [count]="combinationCount"
                [compact]="true"
                (tapped)="onCombinationsTap($event)">
            </app-supplement-combinations-badge>
            <button class="add-to-cart-button-first" *ngIf="!isInCart(product.id) && canEnableOrdering()" (click)="addToCart($event, product)" aria-label="plus">
                <svg class="pill-glyph" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M3.42383 9H15.7988" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9.61133 2.8125V15.1875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <div class="quantity-controls" *ngIf="isInCart(product.id) && canEnableOrdering()">
                <button (click)="updateQuantity($event, product, -1)" aria-label="minus">
                    <svg class="pill-glyph" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path d="M3.42383 9H15.7988" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
                <span>{{getItemQuantity(product.id)}}</span>
                <button (click)="updateQuantity($event, product, 1)" aria-label="plus">
                    <svg class="pill-glyph" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path d="M3.42383 9H15.7988" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M9.61133 2.8125V15.1875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>
        </div>
    </div>
</div>

